import { reconcileCart, quoteCart, getProductInfo } from "../api/shop";
import {
  readCart,
  cartIntent,
  serverCart,
  forgetGuest,
} from "./cartPersistence";
export const restoreCustomerCart = async (customerId, current) => {
  const guest = cartIntent(current);
  const savedCart = readCart(customerId);
  const saved = cartIntent(savedCart, customerId);
  if (
    guest &&
    saved &&
    guest.clientCartId !== saved.clientCartId &&
    guest.modifiedAt === saved.modifiedAt
  )
    throw new Error(
      "Los carritos tienen la misma fecha; conserva ambos hasta resolver el desempate.",
    );
  const candidates = [saved, guest]
    .filter(Boolean)
    .filter(
      (intent, index, all) =>
        all.findIndex((other) => other.clientCartId === intent.clientCartId) ===
        index,
    )
    .sort((a, b) => Date.parse(a.modifiedAt) - Date.parse(b.modifiedAt));
  let response;
  for (const local of candidates.length ? candidates : [null]) {
    response = await reconcileCart(local);
    if (!response || response.error)
      throw new Error(
        response?.message ||
          "No se pudo recuperar el carrito. Tu selección sigue guardada.",
      );
  }
  forgetGuest();
  const cart = serverCart(response.data);
  const previousLines = [
    ...(current?.ShoppingCartProducts || []),
    ...(savedCart?.ShoppingCartProducts || []),
  ];
  cart.ShoppingCartProducts = await Promise.all(
    (cart.ShoppingCartProducts || []).map(async (line) => {
      try {
        const previous = previousLines.find(
          (p) =>
            p.productId === line.productId && p.variantId === line.variantId,
        );
        const [quote, detail] = await Promise.all([
          quoteCart({
            lines: [
              {
                productId: line.productId,
                quantity: line.quantity,
                variantId: line.variantId,
                itemIds: line.itemIds || [],
                note: line.note,
              },
            ],
          }),
          getProductInfo(line.productId),
        ]);
        return {
          ...line,
          Product:
            detail?.error === false
              ? {
                  ...(Array.isArray(detail.data)
                    ? detail.data[0]
                    : detail.data),
                  variants: [
                    ...(Array.isArray(detail.data)
                      ? detail.data[0]?.variants || []
                      : detail.data?.variants || []),
                    ...(previous?.Product?.variants || []).filter(
                      (v) =>
                        !(
                          Array.isArray(detail.data)
                            ? detail.data[0]?.variants || []
                            : detail.data?.variants || []
                        ).some((fresh) => fresh.variantId === v.variantId),
                    ),
                  ],
                }
              : previous?.Product || line.Product,
          unavailable: quote?.error !== false,
        };
      } catch {
        return { ...line, unavailable: true };
      }
    }),
  );
  return cart;
};
